import { render, staticRenderFns } from "./DebtReconciliationModal.vue?vue&type=template&id=22ad0fd6&scoped=true&"
import script from "./DebtReconciliationModal.vue?vue&type=script&lang=js&"
export * from "./DebtReconciliationModal.vue?vue&type=script&lang=js&"
import style0 from "./DebtReconciliationModal.vue?vue&type=style&index=0&id=22ad0fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad0fd6",
  null
  
)

component.options.__file = "DebtReconciliationModal.vue"
export default component.exports